import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { SITE } from "@/data/site";

export default function Enquiry() {
  const [params] = useSearchParams();
  const [form, setForm] = useState({
    name: "", email: "", phone: "",
    subject: params.get("vehicle") ? "Booking request" : "Interstate / long-term hire",
    message: "", vehicle_preference: params.get("vehicle") || "",
    pickup_date: params.get("from") || "", return_date: params.get("to") || "",
  });
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!SITE.formspree_id) {
      const body = encodeURIComponent(
        `Name: ${form.name}\nPhone: ${form.phone}\nVehicle: ${form.vehicle_preference || "No preference"}\nPickup: ${form.pickup_date}\nReturn: ${form.return_date}\n\n${form.message}`
      );
      window.location.href = `mailto:${SITE.contact_email}?subject=${encodeURIComponent(form.subject)}&body=${body}`;
      return;
    }
    setBusy(true);
    try {
      const r = await fetch(`https://formspree.io/f/${SITE.formspree_id}`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ ...form, _subject: `[Top End Wheels] ${form.subject}`, _replyto: form.email }),
      });
      if (!r.ok) throw new Error("Failed");
      setSent(true);
      toast.success("Enquiry sent");
    } catch (err) {
      toast.error("Could not send — please WhatsApp or email us directly.");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-3xl mx-auto px-6 py-16">
      <div className="overline text-[#BA5A3A]">Enquiries &amp; bookings</div>
      <h1 className="text-4xl md:text-5xl font-black tracking-tighter mt-2">Tell us your dates</h1>
      <p className="mt-4 text-[#595959]">Send your dates and vehicle choice — we confirm availability and reply within 24 hrs with a quote and payment details. Interstate, weddings and long-term hires welcome.</p>

      {sent ? (
        <div className="card-hard p-8 mt-8" data-testid="enquiry-sent">
          <h2 className="text-2xl font-black">Thanks — we&apos;ll be in touch shortly.</h2>
          <p className="text-sm text-[#595959] mt-2">We reply within 24 hours. For anything urgent, WhatsApp {SITE.phone}.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="card-hard p-8 mt-8 space-y-4" data-testid="enquiry-form">
          <div className="grid sm:grid-cols-2 gap-4">
            <F label="Your name"><input required value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} className="input" data-testid="enq-name"/></F>
            <F label="Email"><input type="email" required value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} className="input" data-testid="enq-email"/></F>
          </div>
          <div className="grid sm:grid-cols-2 gap-4">
            <F label="Phone"><input value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} className="input" data-testid="enq-phone"/></F>
            <F label="Vehicle preference"><select value={form.vehicle_preference} onChange={e => setForm({ ...form, vehicle_preference: e.target.value })} className="input" data-testid="enq-vehicle">
              <option value="">No preference</option><option value="hilux">Hilux</option><option value="kluger">Kluger</option>
            </select></F>
          </div>
          <div className="grid sm:grid-cols-2 gap-4">
            <F label="Pickup date"><input type="date" value={form.pickup_date} onChange={e => setForm({ ...form, pickup_date: e.target.value })} className="input" data-testid="enq-pickup"/></F>
            <F label="Return date"><input type="date" value={form.return_date} onChange={e => setForm({ ...form, return_date: e.target.value })} className="input" data-testid="enq-return"/></F>
          </div>
          <F label="Subject"><input required value={form.subject} onChange={e => setForm({ ...form, subject: e.target.value })} className="input" data-testid="enq-subject"/></F>
          <F label="Tell us what you need"><textarea rows={5} required value={form.message} onChange={e => setForm({ ...form, message: e.target.value })} className="input" data-testid="enq-message"/></F>
          <button type="submit" disabled={busy} className="btn-ochre disabled:opacity-50" data-testid="enq-submit">{busy ? "Sending…" : "Send enquiry"}</button>
        </form>
      )}
    </div>
  );
}
function F({ label, children }) { return (<label className="block"><div className="overline text-[#595959] mb-1">{label}</div>{children}</label>); }
